module.exports = __webpack_public_path__ + "static/media/icon-4.bf7b4a95.svg";